<template>
  <div class="sidebarMobile">
    <div class="sidebarMobile__burger" @click="toggle">
      <div class="sidebarMobile__burger__bar"></div>
      <div class="sidebarMobile__burger__bar"></div>
      <div class="sidebarMobile__burger__bar"></div>
    </div>
    <transition name="heightTop">
      <div class="sidebarMobile__menu" v-if="isToggle">
        <div class="sidebarMobile__menu__header">
          <div class="sidebarMobile__menu__header--icon" @click="toggle">
            <i class="icon-chevronleft"></i>
          </div>
          <div class="sidebarMobile__menu__header--title">
            <h3>Menu</h3>
          </div>
        </div>
        <div class="sidebarMobile__menu__body">
          <div class="sidebarMobile__menu__wrapper" v-if="isLogin(menu.isLogin)" v-for="(menu, index) in menus" :key="index">
            <div class="sidebarMobile__item">
              <div class="sidebarMobile__item--title">
                <h4 class="subhead">{{menu.title}}</h4>
              </div>
              <template v-for="(item, index) in menu.items" v-if="isLogin(item.isLogin)" >
                <div class="sidebarMobile__item--menu" :key="index" v-if="item.link == `disable`">
                  <i :class="item.icon"></i>
                  <h5 class="subhead">{{item.title}}</h5>
                </div>
                <div class="sidebarMobile__item--menu" :key="index" v-else-if="item.link == `signin`" @click.stop="gotoSignIn">
                  <i :class="item.icon"></i>
                  <h5 class="subhead">{{item.title}}</h5>
                </div>
                <div class="sidebarMobile__item--menu" :key="index" v-else-if="item.link == `signout`" @click.stop="signOut">
                  <i :class="item.icon"></i>
                  <h5 class="subhead">{{item.title}}</h5>
                </div>
                <div class="sidebarMobile__item--menu" :key="index" v-else-if="item.link == `parent`" @click.stop="toggleSub(index)">
                  <i :class="item.icon"></i>
                  <h5 class="subhead">{{item.title}}</h5>
                </div>
                <router-link v-else @click.native="toggle" tag="div" :to="item.link ? {name: item.link} : {path: item.path}" class="sidebarMobile__item--menu" :key="index">
                  <i :class="item.icon"></i>
                  <h5 class="subhead">{{item.title}}</h5>
                </router-link>
                <template>
                  <div v-if="item.subitems" :key="`sub${(index)}`">
                    <adx-sub-item :parent="item" :subitems="item.subitems" v-if="isActive.includes(index)" />
                  </div>
                </template>
              </template>
            </div>
          </div>
        </div>
        <div class="sidebarMobile__menu__footer">

        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Vue from "vue";
import SubItem from '@/components/SideBar/Mobile/Item/SubItem'

export default {
  name: 'adx-sidebar-mobile',
  mounted() {
    
  },
  components: {
    'adx-sub-item': SubItem
  },
  data() {
    return{
      isToggle: false,
      menus: [],
      isActive: []
    }
  },
  methods: {
    loadMenu(file){
      (async () => {
        let request = await fetch(new Request(file))
        let data = await request.json()
        
        this.menus = data.sidemenus
      })()
    },
    toggle() {
      this.isToggle = !this.isToggle
    },
    toggleSub(index){
      if (this.isActive.includes(index)) {
        this.isActive.pop()
      } else {
        this.isActive.pop()
        this.isActive.push(index)
      }
    },
    isLogin(isRequired) {
      const token = this.$store.getters.token
      const isSuperuser = this.$store.getters.isSuperuser
      const groups = this.$store.getters.groups.split(',')

      if(isRequired == true && token) {
        return true
      }
      if (isRequired == true && token == '') {
        return false
      }
      if (isRequired == 'isLogout' && token) {
        return false
      }
      if (isRequired == 'Pertamina') {
        if (isSuperuser) {
          return true
        } else if (groups.includes('Pertamina')) {
          return true
        } else {
          return false
        }
      }

      return true
      
    },
    gotoSignIn() {
      this.toggle()
      Vue.$broker.$emit("openSignin");
    },
    signOut() {
      (async () => {
        const response  = await this.$store.dispatch('removeAccount')

        window.location.reload()
      })();
    }
  },
  watch: {
    isToggle() {
      if(this.isToggle) {
        document.body.style.overflow = "hidden"
        document.documentElement.style.overflow = "hidden"
        document.body.style.position = "relative" 
        document.documentElement.style.overflow = "relative"
        document.body.style.height = "100%" 
        document.documentElement.style.height = "100%"
      }else {
        document.body.style.overflow = '' 
        document.documentElement.style.overflow = ''
        document.body.style.position = '' 
        document.documentElement.style.overflow = ''
        document.body.style.height = '' 
        document.documentElement.style.height = ''
      }
    },
    $route(){
      let fullPath = this.$route.fullPath
      let file = null
      if (fullPath.includes("dashboard")) {
        file = `/static/data/dashboard.json`
      } else {
        file = `/static/data/menus.json`
      }
      this.loadMenu(file)
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>